import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {TipListOverviewRepository} from './repositories/tip-list-overview.repository';
import {TipListOverviewService} from './services/tip-list-overview.service';
import {TipListOverviewRoutingModule} from './tip-list-overview-routing.module';
import {TipListOverviewComponent} from './tip-list-overview.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    TipListOverviewRoutingModule,
    PaginationBootstrapModule,
    ModalConfirmationModule,
    SearchBarModule,
  ],
  declarations: [
    TipListOverviewComponent,
  ],
  providers: [
    TipListOverviewService,
    TipListOverviewRepository,
  ],
})

export class TipListOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-overview/tip-list-overview.module.ts